import React, { useEffect, useState } from "react";
import DevicesRegistered from "../../components/TableSection/TableSection";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import {
  Box,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import DashboardWrapper from "../../layout/DashboardWrapper/DashboardWrapper";
import statusicon from "../../assets/activeStatus.png";
import CustomButton from "../../ui/CustomButton/CustomButton";
import ProfileForm from "../../components/ProfileForm/ProfileForm";
import Grid from "@mui/material/Grid";
import styles from "../../styles/components/profileform.module.scss";
import styles1 from "../../styles/pages/searchdetailed.module.scss";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import CustomInput from "../../components/CustomInput/CustomInput";
import { adminMemberData, convertLowercase, daysjsDateFormat } from "../../services/utils";
import * as yup from "yup";
import validationText from "../../json/messages/validationText";
import useNotiStack from "../../hooks/useNotistack";
import BasicModal from "../../ui/Modal/Modal";
import InputModal from "../../ui/Modal/InputModal";
import {  GetMCMemberProductDetails, GetMCMemeberDetails, UpdateMCMemberDetails, UpdateMCMemberProduct } from "../../api/functions/MCMember.api";
import { GetCountryList, GetStateList } from "../../api/functions/CountryStateList.api";
import DatePickerModal from "../../ui/Modal/DatePickerModal";
import BackdropLoader from "../../ui/BackdropLoader/BackdropLoader";

const schema = yup.object().shape({
  firstName: yup
    .string()
    .trim()
    // .required(
    //   <p style={{ fontSize: "12px" }}>{validationText.error.first_name}</p>
    // )
    ,
  lastName: yup
    .string()
    .trim()
    // .required(
    //   <p style={{ fontSize: "12px" }}>{validationText.error.last_name}</p>
    // )
    ,
  email: yup
    .string()
    .trim()
    .email(validationText.error.email_format)
    // .required(
    //   <p style={{ fontSize: "12px" }}>{validationText.error.enter_email}</p>
    // )
    .matches(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/, 'Email address is not valid'),

  phoneNumber: yup
    .string()
    .trim()
    .matches(/^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/, "please enter proper number"),
  country: yup
    .string()
    .trim()
    // .required(
    //   <p style={{ fontSize: "12px" }}>{validationText.error.country}</p>
    // )
    ,
  address1: yup
    .string()
    .trim()
    // .required(
    //   <p style={{ fontSize: "12px" }}>{validationText.error.address1}</p>
    // )
    ,
  city: yup
    .string()
    .trim()
    // .required(<p style={{ fontSize: "12px" }}>{validationText.error.city}</p>)
    ,
  zip: yup
    .string()
    .trim()
    // .required(<p style={{ fontSize: "12px" }}>{validationText.error.zip}</p>)
    ,
});

function SearchDetailed() {
  const params = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { toastSuccess, toastError } = useNotiStack();
  const user = adminMemberData();

  const [openPasswordModal, setOpenPasswordModal] = useState(false);
  const [openRemoveModal, setOpenRemoveModal] = useState(false);
  const [productRelationshipId, setProductRelationshipId] = useState();
  const [idCountry, setIdCountry] = useState();
  const [stateData, setStateData] = useState([]);
  const [openDeviceStatusModal,setOpenDeviceStatusModal] = useState(false)
  const [openDatePicker, setOpenDatePicker] = useState(false)
  const [subscriptionDetails, setSubscriptionDetails] = useState()
  const [expirationDate, setExpirationDate] = useState()
  // const [anchorEl, setAnchorEl] = React.useState(null);
  // const openMenu = Boolean(anchorEl);

  const {
    handleSubmit,
    control,
    reset,
    setValue,
    watch,
    formState: { errors, isDirty,dirtyFields },
  } = useForm({
    resolver: yupResolver(schema),
    // defaultValues:{
    //   state: undefined
    // }
  });
 
  const {data:MCMemeberDetailsData, isFetching} = useQuery(["MemberDetails", params?.id],
  () => GetMCMemeberDetails({id_member:  Number(params?.id)}, user));

  const MCMemeberProductDetailsData = useQuery(["MemberProductDetails", params?.id],
  () => GetMCMemberProductDetails({id_member:  Number(params?.id)}, user));
  
  const countryData = useQuery(["CountryData"],
    () => GetCountryList({ payload: {}},user));

  const { refetch } = useQuery(["stateListsData", idCountry],
      async () => {
        if (idCountry) {
          const data = await GetStateList({ id_country: idCountry });
          return data;
        }
      },
      {
        onSuccess: (data) => {
          setStateData(data);
        },
        enabled: !!idCountry 
      }
    );

    const { mutateAsync: mutateAsyncUpdateMCMemberDetails, isLoading: updatingDetails } = useMutation({
      mutationFn:(payloadData)=> UpdateMCMemberDetails(payloadData,user),
      onSuccess: (response) => {
        if (response.Status === 1) {
          toastSuccess("Profile updated successfully");
          queryClient.invalidateQueries(["MemberDetails"]);
     
          navigate("/dashboard/search-results")
          // queryClient.invalidateQueries(["memberList"]);
        }else if(response.Status === 502){
          toastError(`${response?.ErrorDetails.propertyName} ${convertLowercase(response.ErrorMessage)}.`)
        }else{
          toastError("Something went wrong")
        }
      },
    });
    const { mutateAsync: mutateAsyncUpdateMCMemberProduct,isLoading:isLoadingProductUpdate  } = useMutation({
      mutationFn:(payloadData)=> UpdateMCMemberProduct(payloadData,user),
      onSuccess: (response) => {
      
        if (response.Status === 1) {
          toastSuccess(response.ErrorMessage);
          setOpenDeviceStatusModal(false)
          setOpenDatePicker(false)
          setExpirationDate(undefined)
          setSubscriptionDetails(undefined)
          queryClient.invalidateQueries(["MemberProductDetails"]);
        }
      },
    }); 
    useEffect(() => {
      setIdCountry(MCMemeberDetailsData?.id_country);
    }, [MCMemeberDetailsData?.id_country]);

    useEffect(() => {
      reset({
        firstName: MCMemeberDetailsData?.firstName,
        lastName: MCMemeberDetailsData?.lastName,
        email: MCMemeberDetailsData?.email,
        phoneNumber:MCMemeberDetailsData?.phone,
        country: MCMemeberDetailsData?.id_country,
        address1: MCMemeberDetailsData?.address1,
        address2:MCMemeberDetailsData?.address2,
        city: MCMemeberDetailsData?.city,
        state: MCMemeberDetailsData?.id_state,
        otherState: MCMemeberDetailsData?.otherState,
        zip: MCMemeberDetailsData?.zipCode,
      });
    }, [MCMemeberDetailsData]);

    // useEffect(() => {

    //   if(expirationDate && subscriptionDetails){
    //     const updatedSubscriptionDetails = {
    //       ...subscriptionDetails,
    //       dateExpiration: expirationDate 
    //     };
       
    //    const payload = {
    //       id_relationship: productRelationshipId,
    //       subscriptionList: [updatedSubscriptionDetails]
    //    }
    //     mutateAsyncUpdateMCMemberProduct(payload)
    //   }
        
    //  }, [subscriptionDetails,expirationDate])

  const openResetPasswordModal = () => {
    setOpenPasswordModal(true);
  };
  
  const handleClose = () => {
    setOpenPasswordModal(false);
  };

  const closeModal = () => {
    setOpenDeviceStatusModal(false)
  };

  const handleSelectCountry = (e, valueCountryId) => {
      setStateData(null);
      setValue('state', null);
      setIdCountry(valueCountryId);
  }
    

  const onSubmit = (data) => {

    const formData = new FormData();

  const fields = {
    firstName: "firstName",
    lastName: "lastName",
    email: "email",
    phoneNumber: "phone",
    country: "id_country",
    address1: "address1",
    address2: "address2",
    state: "id_state",
    city: "city",
    otherState: "otherState",
    zip: "zipCode",
  
  };
  
  Object.entries(fields).forEach(([field, key]) => {
    if (dirtyFields[field]) {
      formData.append(key, data?.[field] || "");
    }
  });

      formData.append("id_member", Number(params?.id))

    mutateAsyncUpdateMCMemberDetails(formData);
  };



  // ChangeCustomerDeviceStatus

  // const redirectToDetails =(e,productId)=>{
  //   navigate(`/dashboard/product-detailed/${productId}`);
  // }

  const deviceStatusChange = (event, product_relationship_id) => {
    event.stopPropagation();
    setProductRelationshipId(product_relationship_id);
    // setAnchorEl(event.currentTarget);
    setOpenDeviceStatusModal(true)
  };

  const changeDeviceStatus =(e,value)=>{
   e.stopPropagation();
   const payload = {
     id_relationship: productRelationshipId,
     active: 0  //  for inactive
   }
      mutateAsyncUpdateMCMemberProduct(payload)
  } 

 const updateProductSubscription = (e,id,subscriptionData)=>{
   e.stopPropagation();
   setProductRelationshipId(id)
   setSubscriptionDetails(subscriptionData)
   setOpenDatePicker(true)
 }


  const handleSubscriptionDate = (date)=>{
    setExpirationDate(date?.format("YYYY-MM-DD HH:mm:ss"))
   }


  return (
    <DashboardWrapper
      showBtmHeader>
   <BackdropLoader open={isFetching} />
      <ProfileForm formHeader="Customer Profile">
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container rowSpacing={4} columnSpacing={2}>
            <Grid item xs={12} lg={5} md={6} sm={6}>
              <Box className={styles.profile_grid}>
                <Stack
                  flexDirection="row"
                  className={styles.profile_stack}
                  alignItems="center"
                >
                  <label>First Name</label>
                  <Box className={styles.form_input_group}>
                    <Controller
                      control={control}
                      name="firstName"
                      render={({ field: { onChange, value } }) => (
                        <CustomInput
                          type="text"
                          value={value || ""}
                          onChange={onChange}
                          // error={Boolean(errors?.firstName)}
                          // helperText={errors?.firstName?.message}
                        />
                      )}
                    />
                  </Box>
                </Stack>
              </Box>
              <Box className={styles.profile_grid}>
                <Stack
                  flexDirection="row"
                  className={styles.profile_stack}
                  alignItems="center"
                >
                  <label>Last Name</label>
                  <Box className={styles.form_input_group}>
                    <Controller
                      control={control}
                      name="lastName"
                      render={({ field: { onChange, value } }) => (
                        <CustomInput
                          type="text"
                          value={value || ""}
                          onChange={onChange}
                          // error={Boolean(errors?.lastName)}
                          // helperText={errors?.lastName?.message}
                        />
                      )}
                    />
                  </Box>
                </Stack>
              </Box>
              <Box className={styles.profile_grid}>
                <Stack
                  flexDirection="row"
                  className={styles.profile_stack}
                  alignItems="center"
                >
                  <label>Email</label>
                  <Box className={styles.form_input_group}>
                    <Controller
                      control={control}
                      name="email"
                      render={({ field: { onChange, value } }) => (
                        <CustomInput
                          type="email"
                          value={value || ""}
                          onChange={onChange}
                          // error={Boolean(errors?.email)}
                          // helperText={errors?.email?.message}
                        />
                      )}
                    />
                  </Box>
                </Stack>
              </Box>
              <Box className={styles.profile_grid}>
                <Stack
                  flexDirection="row"
                  className={styles.profile_stack}
                  alignItems="center"
                >
                  <label>Phone Number</label>
                  <Box className={styles.form_input_group}>
                    <Controller
                      control={control}
                      name="phoneNumber"
                      render={({ field: { onChange, value } }) => (
                        <CustomInput
                          type="text"
                          onKeyPress={(e) => {
                            if (e.key === "e"|| e.key === "E" || e.key === "-") {
                              e.preventDefault()
                            }
                          }}
                          value={value || ""}
                          onChange={onChange}
                          // error={Boolean(errors?.phoneNumber)}
                          // helperText={errors?.phoneNumber?.message}
                        />
                      )}
                    />
                  </Box>
                </Stack>
              </Box>
              <Box className={`${styles.profile_grid} ${styles.mb_0}`}>
                <Stack
                  flexDirection="row"
                  className={styles.profile_stack}
                  alignItems="center"
                >
                  <label>Country</label>
                  <Box className={styles.form_input_group}>
                    <Controller
                      control={control}
                      name="country"
                      render={({ field: { onChange, value } }) => (
                        <Box className={styles.selectWrap}>
                          <Select
                            className={styles.cmn_slct}
                            //  defaultValue="Select Country"
                            id="demo-simple-select"
                            onChange={onChange}
                            // value={value}
                            value={value ? value : ""}
                            MenuProps={{
                              PaperProps: {
                                sx: {
                                  maxHeight: "200px;"
                                },
                              },
                            }}
                          >
                            {countryData?.data?.countryList.map((e, index) => (
                              <MenuItem key={e?.id_country} value={e?.id_country} 
                              onClick={
                                (event) =>handleSelectCountry(event, e?.id_country)
                              } >
                                <Typography
                                  variant="body1"
                                  className="menu_para"
                                >
                                  {e?.countryFull}
                                </Typography>
                              </MenuItem>
                            ))}
                          </Select> 
                        </Box>
                      )}
                    />
                    {errors.country && (
                      <p className={styles.error_text}>
                        {validationText.error.country}
                      </p>
                    )}
                  </Box>
                </Stack>
              </Box>
            </Grid>
            <Grid item xs={12} lg={5} md={6} sm={6}>
              <Box className={styles.profile_grid}>
                <Stack
                  flexDirection="row"
                  className={styles.profile_stack}
                  alignItems="center"
                >
                  <label>Address1</label>
                  <Box className={styles.form_input_group}>
                    <Controller
                      control={control}
                      name="address1"
                      render={({ field: { onChange, value } }) => (
                        <CustomInput
                          type="text"
                          value={value || ""}
                          onChange={onChange}
                          // error={Boolean(errors?.address1)}
                          // helperText={errors?.address1?.message}
                        />
                      )}
                    />
                  </Box>
                </Stack>
              </Box>
              <Box className={styles.profile_grid}>
                <Stack
                  flexDirection="row"
                  className={styles.profile_stack}
                  alignItems="center"
                >
                  <label>Address2</label>
                  <Box className={styles.form_input_group}>
                    <Controller
                      control={control}
                      name="address2"
                      render={({ field: { onChange, value } }) => (
                        <CustomInput
                          type="text"
                          value={value || ""}
                          onChange={onChange}
                          // error={Boolean(errors?.address2)}
                          // helperText={errors?.address2?.message}
                        />
                      )}
                    />
                  </Box>
                </Stack>
              </Box>
              <Box className={styles.profile_grid}>
                <Stack
                  flexDirection="row"
                  className={styles.profile_stack}
                  alignItems="center"
                >
                  <label>City</label>
                  <Box className={styles.form_input_group}>
                    <Controller
                      control={control}
                      name="city"
                      render={({ field: { onChange, value } }) => (
                        <CustomInput
                          type="text"
                          value={value || ""}
                          onChange={onChange}
                          // error={Boolean(errors?.city)}
                          // helperText={errors?.city?.message}
                        />
                      )}
                    />
                  </Box>
                </Stack>
              </Box>
              <Box className={styles.profile_grid}>
                <Stack
                  flexDirection="row"
                  className={styles.profile_stack}
                  alignItems="center"
                >
                  <label>State</label>
                  <Box className={styles.form_input_group}>
                    <Controller
                      control={control}
                      name="state"
                      key={watch("country")}
                      render={({ field: { onChange, value } }) => (
                        <Box className={styles.selectWrap}>
                        
                        {/* {stateData && stateData !== null && stateData?.length !== 0 ?  */}
                       {stateData?.stateList?.length !== 0 ?
                          <Select
                          className={styles.cmn_slct}
                          id="demo-simple-select"
                          onChange={onChange}
                          // value={value}
                          value={value ? value : ""}
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                maxHeight: "200px;"
                              },
                            },
                          }}
                        >
                          {stateData?.stateList?.map((e, index) => (
                            <MenuItem key={e?.id_state} value={e?.id_state}>
                              <Typography
                                variant="body1"
                                className="menu_para"
                              >
                                {e?.stateFull}
                              </Typography>
                            </MenuItem>
                          ))}
                        </Select> 
                       : <Select className={styles.cmn_slct}>
                       <MenuItem disabled>
                       <Typography variant="body1" className="menu_para" >-No State Available-</Typography>
                         </MenuItem>
                       </Select>
                       }
                        </Box>
                      )}
                    />
                    {/* {errors.state && (
                      <p className={styles.error_text}>
                        {validationText.error.state}
                      </p>
                    )} */}
                  </Box>
                </Stack>
              </Box>
              <Box className={`${styles.profile_grid} ${styles.mb_0}`}>
                <Stack
                  flexDirection="row"
                  className={styles.profile_stack}
                  alignItems="center"
                >
                  <label>Other State/Zip Code</label>
                  <Box className={styles.form_input_group}>
                    <Grid
                      container
                      spacing={2}
                      columnSpacing={{ lg: 2, md: 1, sm: 1 }}
                    >
                      <Grid item xs={12} md={6} sm={6}>
                        <Controller
                          control={control}
                          name="otherState"
                          render={({ field: { onChange, value } }) => (
                            <CustomInput
                              type="text"
                              value={value || ""}
                              onChange={onChange}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} sm={6}>
                        <Controller
                          control={control}
                          name="zip"
                          render={({ field: { onChange, value } }) => (
                            <CustomInput
                              type="text"
                              value={value || ""}
                              onChange={onChange}
                              // error={Boolean(errors?.zip)}
                              // helperText={errors?.zip?.message}
                            />
                          )}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Stack>
              </Box>
            </Grid>

            <Grid item xs={12} lg={2} md={12} sm={12}>
              <Box className={styles.profile_btn}>
                <CustomButton onClick={openResetPasswordModal}>
                  <Typography variant="caption">Reset Password</Typography>
                </CustomButton>

                <Box className={styles1.blue_btn}>
                  <CustomButton type="submit" disabled={isDirty === false} loading={updatingDetails}>
                    {" "} <Typography variant="caption">
                    {updatingDetails ? "Saving.." : "Save Profile"}
                    </Typography>
                 
                  </CustomButton>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </form>
      </ProfileForm>


      <Box className={styles1.tabletitle}>
        <Typography variant="h4">Devices Registered</Typography>
      </Box>
      <DevicesRegistered>
        <TableHead>
          <TableRow>
            <TableCell align="center">
              <Typography variant="body1">Device Name</Typography>
            </TableCell>
            <TableCell align="center">
              <Typography variant="body1">Serial Number</Typography>
            </TableCell>
            <TableCell align="center">
              {/* <Typography variant="body1">Standard Plan</Typography> */}
              <Typography variant="body1">SIM Expiration</Typography>   
            </TableCell>
            <TableCell align="center">
            {/* <Typography variant="body1">Premium Plan</Typography> */}
              <Typography variant="body1">Registration Expiration</Typography>
            </TableCell>
            <TableCell align="center">
              <Typography variant="body1">Status</Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
    
          {MCMemeberProductDetailsData?.data?.productList?.length !== 0 ? (
            <>
              {MCMemeberProductDetailsData?.data?.productList?.map((row) => (
                <TableRow key={row.deviceName} >
                  <TableCell align="center" scope="row">
                    <Typography variant="body1">{row.productName}</Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body1">{row.serialNumber}</Typography>
                  </TableCell>
                  <TableCell align="center">
                 
                    <Typography variant="body1">
                      {daysjsDateFormat(row?.dateSIMExpires)}
                    {/* {daysjsDateFormat(row?.subscriptionList[0]?.dateExpiration)} */}
                    {/* <button className={styles1.icon} onClick={(event) => updateProductSubscription(event, row?.id_relationship,row?.subscriptionList[0] )}>
                          <img src={statusicon} alt="" />
                        </button> */}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography variant="body1">
                    {daysjsDateFormat(row?.subscriptionList[1]?.dateExpiration)}
                    {/* <button className={styles1.icon}
                          onClick={(event) =>
                            updateProductSubscription(event, row?.id_relationship,row?.subscriptionList[1] )
                          }
                        >
                          <img src={statusicon} alt="" />
                        </button> */}
                    </Typography>
                  </TableCell>
                    <TableCell align="center">
                    {row.active === 1 ?    
                    <Typography variant="body1" 
                    // className={row.status !== "Active" && styles1.inactive}
                    >
                      Active
                        <button className={styles1.icon}
                          onClick={(event) =>
                            deviceStatusChange(event, row?.id_relationship)
                          }
                        >
                          <img src={statusicon} alt="" />
                        </button>
                      </Typography> :  <Typography variant="body1" className={row.status !== "Active" && styles1.inactive}>
                      Inactive
                        {/* <button className={styles1.icon}>
                        </button> */}
                      </Typography>}
                   
                    </TableCell>

                    
                       <BasicModal open={openDeviceStatusModal}  
                        onClose={closeModal}
                        title="Deactivate Device?" 
                        content="Are you sure you want to deactivate this device from this user and delete it from their account?" 
                        statusChangeList
                        yesBtnClick={(e)=> changeDeviceStatus(e)}
                        // menuList={deviceStatusList[0]?.value}
                        noBtnClick={(event)=> { event.stopPropagation();setOpenDeviceStatusModal(false)} } 
                        />
                </TableRow>
              ))}
            </>
          ) : (
            <TableCell colSpan={9} className={styles.no_data}>
              No Device found
            </TableCell>
          )}
        </TableBody>

        <DatePickerModal open={openDatePicker} 
            subscriptionDate={handleSubscriptionDate} 
            onClose={() => setOpenDatePicker(false)}
            dateOfExpiration={subscriptionDetails?.dateExpiration}
            isLoadingProductUpdate={isLoadingProductUpdate} />
      </DevicesRegistered>

      <InputModal
        open={openPasswordModal}
        onClose={handleClose}
        title="Change Account Password"
        cancleBtnClick={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      />
    </DashboardWrapper>
  );
}

export default SearchDetailed;
